import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { ScrollArea } from '../../../components/ui/scroll-area';

interface OrderDetailsItem {
    material_name: string;
    material_desc: string;
    qty: number;
}

interface OrderDetailsData {
    items: OrderDetailsItem[];
    ewaybill_numbers: string[];
    invoice_numbers: string[];
}

interface OrderDetailsProps {
    orderDetails: OrderDetailsData;
    className?: string;
}

const OrderDetails: React.FC<OrderDetailsProps> = ({ orderDetails, className = '' }) => {
    return (
        <Card className={`bg-white shadow-sm ${className}`}>
            <CardContent className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Order Details</h3>

                <ScrollArea className="flex-1 min-h-0">
                    {/* Items */}
                    <div className="mb-6">
                        <h4 className="text-sm font-medium text-gray-700 mb-3">Items (as per E-Way Bill)</h4>
                        <div className="space-y-2">
                            {orderDetails.items.map((item, index) => (
                                <div key={index} className="flex justify-between items-center py-3 px-3 bg-gray-50 rounded">
                                    <div className="flex-1">
                                        <div className="text-sm font-medium text-gray-900">{item.material_name}</div>
                                        <div className="text-xs text-gray-600 mt-1">{item.material_desc}</div>
                                    </div>
                                    <span className="text-sm font-medium text-gray-700 ml-4">Qty: {item.qty}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* eWay Bill Numbers */}
                    <div className="mb-6">
                        <h4 className="text-sm font-medium text-gray-700 mb-3">EWay Bill Numbers</h4>
                        <div className="flex flex-wrap gap-2">
                            {orderDetails.ewaybill_numbers.map((ewayBill, index) => (
                                <span key={index} className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                    {ewayBill}
                                </span>
                            ))}
                        </div>
                    </div>

                    {/* Invoice Numbers */}
                    <div className="mb-6">
                        <h4 className="text-sm font-medium text-gray-700 mb-3">Invoice Numbers</h4>
                        <div className="flex flex-wrap gap-2">
                            {orderDetails.invoice_numbers.map((invoice, index) => (
                                <span key={index} className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                    {invoice}
                                </span>
                            ))}
                        </div>
                    </div>
                </ScrollArea>
            </CardContent>
        </Card>
    );
};

export default OrderDetails;
